import { Box, Button, Stack, Typography, ValidationErrors } from "@compass/core";
import {
  StudentService,
  StudentServiceAdditionalEntry,
  StudentServiceEditResource,
  StudentServiceType,
  StudentServiceViewResource,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { AdditionalEntry } from "./AdditionalEntry";

export const AdditionalEntries = (props: {
  originalService: StudentService;
  entries: StudentServiceAdditionalEntry[];
  setEntries: (value: StudentServiceAdditionalEntry[]) => void;
  viewResource: StudentServiceViewResource;
  editResource: StudentServiceEditResource;
  serviceTypes: StudentServiceType[];
  validationErrors: ValidationErrors | string[];
}) => {
  return (
    <Stack spacing="sm" width="100%">
      {props.entries.length > 0 && (
        <Stack>
          {props.entries.map((entry, index) => (
            <Stack
              border={(theme) => `1px solid ${theme.palette.border.dark}`}
              borderTop={index !== 0 ? "none" : "default"}
            >
              <AdditionalEntry
                entry={entry}
                setEntry={(value) =>
                  props.setEntries(
                    produce(props.entries, (draft) => {
                      draft[index] = value;
                    })
                  )
                }
                viewResource={props.viewResource}
                editResource={props.editResource}
                serviceTypes={props.serviceTypes}
                cancelCreate={() =>
                  props.setEntries(
                    produce(props.entries, (draft) => {
                      draft.splice(index, 1);
                    })
                  )
                }
                validationErrors={props.validationErrors[index] || []}
              />
            </Stack>
          ))}
        </Stack>
      )}

      <Stack direction="row" spacing="sm">
        <Button
          onClick={() =>
            props.setEntries(
              produce(props.entries, (draft) => {
                draft.push({} as StudentServiceAdditionalEntry);
              })
            )
          }
          variant="text"
          size="small"
        >
          <Typography variant="inherit" style={{ textTransform: "none" }}>
            + Additional Services
          </Typography>
        </Button>

        <Button
          onClick={() =>
            props.setEntries(
              produce(props.entries, (draft) => {
                // copy the sevice type and subtype from top
                draft.push({
                  serviceTypeId: props.originalService.serviceTypeId,
                  serviceSubTypeId: props.originalService.serviceSubTypeId,
                } as StudentServiceAdditionalEntry);
              })
            )
          }
          variant="text"
          size="small"
          sx={{ minWidth: "auto" }}
        >
          <Typography variant="inherit" style={{ textTransform: "none" }}>
            + Copy
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
};
